import React, { ReactElement } from "react";
import TimeAgo from "react-timeago";
import useRouting, { Link } from "../../contexts/Routing";
import { NoDataOrError } from "../../pages/error/Error";
import { TicketPriority, useGetTicketsByCreatorQuery } from "../../__generated__/api";
import Loading from "../loading/Loading";
import Styles from "./ListTickets.module.scss";

interface Props {
    id: string;
    excludeId?: string;
}

export default function ListTickets({ id, excludeId }: Props): ReactElement {
    const { data, error, loading } = useGetTicketsByCreatorQuery({ variables: { id } });
    const { Paths } = useRouting();

    if (loading) {
        return <Loading />;
    }
    const tickets = data?.tickets
        .sortByDescending(ticket => new Date(ticket.createdDate).getTime())
        .filter(ticket => ticket.chatId && ticket.chatId !== excludeId && ticket.id !== excludeId);
    if (error || !tickets) {
        return <NoDataOrError error={error} />;
    }

    return (
        <div>
            <div className="list-group list-group-flush ">
                {tickets.map(ticket => {
                    const classNames = ["list-group-item list-group-item-action text-gray-800"];
                    classNames.push(Styles["ticket-item"]);
                    classNames.push(Styles[`ticket-item-${(ticket.priority ?? TicketPriority.Medium).toLowerCase()}`]);

                    const date = new Date(ticket.createdDate);
                    return (
                        <Link
                            to={Paths.AGENT_CHAT}
                            params={{
                                chatId: ticket.ticketNumber ?? ticket.chatId ?? ticket.id,
                            }}
                            className={classNames.join(" ")}
                            key={ticket.id}
                        >
                            <div>
                                {ticket.subject}
                            </div>
                            <small>
                                <TimeAgo
                                    date={date}
                                    minPeriod={60}
                                    title={`${date.toLocaleDateString()} ${date.toLocaleTimeString()}`}
                                />
                            </small>
                        </Link>
                    );
                })}

            </div>

        </div>
    );
}

ListTickets.defaultProps = {
    excludeId: undefined,
};
